import { Modal } from 'antd';
import styled from 'styled-components';

export const ModalWrapper = styled(Modal)`
  &.reset-padding-body .ant-modal-content {
    padding-right: 0 !important;
    padding-left: 0 !important;
    padding-top: 16px !important;
    .ant-modal-header {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
`;

export const DelModalStyles = styled(Modal)`
  .delModal {
    &-icon {
      font-size: 22px;
      min-width: 22px;
      margin-top: 2px;
      color: var(--primary);
    }
    &-wrap {
      margin-bottom: 30px;
      display: flex;
      gap: 11px;
    }
  }
`
